import { ReactNode, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { PrintContext } from './PrintContext';

interface PrintProviderProps {
  children: ReactNode;
}

export function PrintProvider({ children }: PrintProviderProps) {
  const contentRef = useRef<any>();
  const onPrint = useReactToPrint({
    contentRef,
    pageStyle: `
      @page {
        size: auto;
        margin: 20mm;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          display: flex;
          justify-content: center;
        }
      }
    `,
  });

  return <PrintContext.Provider value={{ contentRef, onPrint }}>{children}</PrintContext.Provider>;
}
